






import Vue from 'vue'

export default Vue.extend({
  inheritAttrs: false,
  name: 'XButtonGroup',
  props: {},
  methods: {
    handleClick(event: UIEvent) {
      this.$emit('click', event)
    },
  },
})
